import { Reducer } from "redux"
import { matchPath } from "react-router"
import { RouterAction, LOCATION_CHANGE } from "connected-react-router"

import { AuthUserType, InboxType } from "../../../Actions/Types"
import { AppInboxSettings } from "../../../Models/API/AppSettings"
import { abstractRoutePaths } from "../../../Routes"
import { AuthAction } from "../../Auth"

export interface InboxState {
    inbox?: AppInboxSettings | null
    isVerified?: boolean
}

interface GetInboxAction {
    type: InboxType.getInbox
    payload: AppInboxSettings | null
}

interface CreateInboxAction {
    type: InboxType.createInbox
}

interface VerifyInboxAction {
    type: InboxType.verifyInbox
    payload: {
        is_verified: boolean
    }
}

interface DeleteInboxAction {
    type: InboxType.deleteInbox
}

export type InboxAction =
    | GetInboxAction
    | CreateInboxAction
    | VerifyInboxAction
    | DeleteInboxAction

const initialState: InboxState = {}

export const InboxReducer: Reducer<
    InboxState,
    InboxAction | AuthAction | RouterAction
> = (state = initialState, action): InboxState => {
    switch (action.type) {
        case LOCATION_CHANGE:
            const isAppSettings =
                matchPath(action.payload.location.pathname, {
                    path: abstractRoutePaths.appSettings
                }) !== null

            return isAppSettings
                ? state
                : {
                      ...state,
                      inbox: undefined,
                      isVerified: undefined
                  }
        case InboxType.getInbox:
            return {
                ...state,
                inbox: action.payload
            }
        case InboxType.verifyInbox:
            return {
                ...state,
                isVerified: action.payload?.is_verified
            }
        case AuthUserType.signedOut:
            return initialState
        default:
            return state
    }
}
